import React, { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import { fetchNews } from "../../../../redux/slice/homeSlice/sliceHome";
import Spinner from "../../Components/Spinner";

const WhatsNew = () => {
  const [playPause, setPlayPause] = useState(false);
  const dispatch = useDispatch();
  const { news, loading } = useSelector((state) => state.sliceHome);

  useEffect(() => {
    dispatch(fetchNews("get-news"));
  }, [dispatch]);

  const slider = useRef();
  //slider settings
  const settings = {
    arrows: false,
    infinite: true,
    speed: 5000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    dots: true,
  };

  const HandlePlayPause = () => {
    if (loading) {
      return <Spinner />;
    }

    setPlayPause(!playPause);
    if (playPause) {
      slider.current.slickPlay();
    }
    if (!playPause) {
      slider.current.slickPause();
    }
  };

  const next = () => {
    slider.current.slickNext();
  };
  const prev = () => {
    slider.current.slickPrev();
  };
  return (
    <>
      <div className="news-area graybg">
        <div className="container-fluid drk-gray-bg">
          <div className="row">
            <div className="col-12 col-sm-12 col-md-12 col-lg-12 p-0 mob-ver-pad">
              <div className="news-inner drk-gray-bg">
                <div className="news-control-sec">
                  <div className="news-control">
                    <div className="news-left-right">
                      <h5>
                        Dharma <span className="ht-light">News</span>
                      </h5>
                      <a type="button" onClick={prev} className="prev-btn">
                        <i className="fas fa-chevron-left"></i>
                      </a>
                      <a
                        className="pause-btn"
                        type="button"
                        onClick={HandlePlayPause}
                      >
                        {!playPause ? (
                          <i className="fas fa-pause"></i>
                        ) : (
                          <i className="fas fa-play"></i>
                        )}
                      </a>
                      <a type="button" onClick={next} className="next-btn">
                        <i className="fas fa-chevron-right"></i>
                      </a>
                    </div>
                  </div>
                  <div className="whhats-new-slider">
                    <div>
                      <div className="carousel-inner">
                        <Slider {...settings} ref={slider}>
                          {news.data && news.data.length > 0 ? (
                            news.data.map((item) => (
                              <div className="carousel-item" key={item.id}>
                                <a href="#">
                                  {/* <span className="pink-txt">
                                    {moment(item.news_date).format(
                                      "MMMM, Do YYYY"
                                    )}
                                  </span> */}
                                  {item.title}
                                </a>
                              </div>
                            ))
                          ) : (
                            <div>No data Found</div>
                          )}
                        </Slider>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="read-more-sec">
                  <Link to={"/whats-new"} className="blue-btn">
                    Read More
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default WhatsNew;
